export const SITE_URL = "https://restlicht.fyi";
export const SITE_NAME = "Restlicht.FYI";
export const DEFAULT_OG_IMAGE = "https://restlicht.fyi/og-home.jpg";
export const BLOG_OG_IMAGE = "https://restlicht.fyi/og-blog.jpg";

type BuildMetaInput = {
  /** Seitentitel ohne Marke, z.B. "Blog" */
  title: string;
  description: string;
  /** Pfad mit fuehrendem Slash, z.B. "/blog" */
  path: string;
  type?: "website" | "article";
  /** Absolute oder relative URL zum Vorschaubild */
  image?: string;
  noindex?: boolean;
};

export function absoluteUrl(path: string): string {
  if (/^https?:\/\//.test(path)) return path;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export function pageTitle(title: string): string {
  return title === SITE_NAME ? title : `${title} - ${SITE_NAME}`;
}

/**
 * Erzeugt Titel, Description, Open-Graph-, Twitter- und Canonical-Tags
 * aus einem Seitentitel und einer Beschreibung.
 */
export function buildMeta({
  title,
  description,
  path,
  type = "website",
  image,
  noindex = false,
}: BuildMetaInput) {
  const fullTitle = pageTitle(title);
  const url = absoluteUrl(path);

  const meta: Array<Record<string, string>> = [
    { title: fullTitle },
    { name: "description", content: description },
    { property: "og:title", content: fullTitle },
    { property: "og:description", content: description },
    { property: "og:type", content: type },
    { property: "og:url", content: url },
    { name: "twitter:title", content: fullTitle },
    { name: "twitter:description", content: description },
  ];

  const imageUrl = absoluteUrl(image ?? DEFAULT_OG_IMAGE);
  meta.push(
    { property: "og:image", content: imageUrl },
    { name: "twitter:image", content: imageUrl },
  );


  if (noindex) {
    meta.push({ name: "robots", content: "noindex" });
    return { meta };
  }

  return {
    meta,
    links: [{ rel: "canonical", href: url }],
  };
}
